import { useState } from "react";

interface Props {
  label: string;
  id: string;
  defaultValue?: string;
  value?: string;
  dataTextField: string;
  dataValueField: string;
  handleChange?: any;
  rows: any[];
  customLeftCols?: any; // for example col-sm-3
  customRightCols?: any; // for example col-sm-9
  disabled?:any;
}

const ComboBoxData = (props: Props) => {

  let leftColumnClass = `${props.customLeftCols ?? "col-sm-3"
    } col-form-label zvlabel`;

  let rightColumnClass = `${props.customRightCols ?? "col-sm-9"}`;

  return (
    <div className="row">
      {props.label && (
        <label htmlFor={props.id} className={leftColumnClass}>
          {props.label}
        </label>
      )}
      <div className={rightColumnClass}>
        <select
          disabled={props.disabled}
          key={props.id}
          title={props.label}
          value={props.value ?? undefined}
          defaultValue={props.defaultValue ?? undefined}
          onChange={(event) => {
            if (props.handleChange) {
              props.handleChange(event.target.value);
            }
          }}
          id={props.id}
          className="form-select"
        >
          {props.rows.map((row: any) => {

            return (
              <option
                value={row[props.dataValueField]}>
                {row[props.dataTextField]}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
};

export default ComboBoxData;
